var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-bottom":"2rem"}},[_c('header-filter',{ref:"headerFilter",attrs:{"icon":"people"},on:{"updateParent":_vm.updateFilter,"downloadClick":_vm.downloadClickData}}),_c('standard-table',{ref:"table",on:{"updateTotal":_vm.updateTotal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }